import { formatIST, formatDueIn } from "../../utils/formatDate";
import { SubmissionStatusBadge, SubmissionTypeBadge } from "./SubmissionBadges";

export default function RequestCard({ request, onClick }) {
  const isResolved = (request.status || "").toLowerCase() === "resolved";
  const isOverdue = /overdue/i.test(request.due_in || "");

  return (
    <button
      onClick={onClick}
      className="bg-white rounded-xl border border-gray-200 p-4 text-left"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-gray-800">
          {request.request_id || request.id}
        </span>
        <SubmissionStatusBadge status={request.status} />
      </div>
      <div className="mb-2">
        <SubmissionTypeBadge type={request.submission_type} />
      </div>
      <div className="text-xs text-gray-400">
        Raised On :{" "}
        <span className="text-gray-600 font-medium">
          {formatIST(request.created_at)}
        </span>
      </div>
      {!isResolved && (
        <div className="text-xs text-gray-400 mt-1">
          Response Due In :{" "}
          <span
            className={`font-medium ${isOverdue ? "text-[#C73838]" : "text-gray-600"}`}
          >
            {formatDueIn(request.due_in) || "-"}
          </span>
        </div>
      )}
    </button>
  );
}
